<template>
  <div>
    <div class="page-content">
      <div class="col-lg-12 col-xl-12 stretch-card">
        <div class="card">
          <div class="card-header">
            <h4 style="margin-right: 5px" class="float-start">
              Master Activity List
            </h4>

            <button
              v-if="this.permision_role.method_create"
              class="btn btn-primary float-end btn-xs"
              style="margin-right: 5px"
              @click.prevent="addData()"
            >
              <i class="link-icon" data-feather="plus"></i>
              {{ $t("createNew") }}
            </button>
            <button
              v-if="this.permision_role.method_read"
              class="btn btn-success float-end btn-xs"
              style="margin-right: 5px"
              @click.prevent="downloadData()"
            >
              <i class="link-icon" data-feather="download"></i>
              {{ $t("downloadData") }} .xlsx
            </button>
          </div>
          <div class="card-body">
            <vue-good-table
              title="list-master-activity"
              mode="remote"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :line-numbers="true"
              :isLoading.sync="isLoading"
              :pagination-options="{
                enabled: true,
              }"
              :select-options="{
                enabled: true,
                selectOnCheckboxOnly: true,
                selectionText: $t('data_selected'),
                clearSelectionText: $t('clear'),
              }"
              :rows="rows"
              :columns="columns"
              @on-selected-rows-change="onRowSelected"
            >
              <div slot="selected-row-actions">
                <button
                  class="btn btn-danger btn-xs"
                  v-if="permision_role.method_delete"
                  @click="deleteModal"
                >
                  <i class="mdi mdi-delete-empty"></i> Delete
                </button>
              </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <a
                    style="margin-right: 10px"
                    href="#"
                    title="Detail"
                    @click.prevent="detailData(props.index, props.row)"
                  >
                    <i class="mdi mdi-eye" style="font-size: 16px"></i>
                  </a>
                  <a
                    href="#"
                    v-if="permision_role.method_update"
                    title="Edit"
                    @click.prevent="editData(props.index, props.row)"
                  >
                    <i
                      class="mdi mdi-square-edit-outline"
                      style="font-size: 16px"
                    ></i>
                  </a>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import moment from "moment";
//import DateRangePicker from "vue2-daterange-picker";
//import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
//import modalCancelFppk from "@/components/modal/modalCancelFppk.vue";

export default {
  name: "FppkMasterActivity",
  components: {
    //DateRangePicker,
    //"modal-cancel-fppk": modalCancelFppk,
  },
  data() {
    return {
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: "Action",
          thClass: "text-left",
          //tdClass: "text-left",
          field: "actions",
          width: "80px",
          sortable: false,
        },
        {
          label: "Category",
          thClass: "text-left",
          tdClass: "text-left",
          field: "category",
          //width: "80px",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Job No",
          thClass: "text-left",
          tdClass: "text-left",
          field: "job_no",
          //width: "80px",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Description",
          thClass: "text-left",
          tdClass: "text-left",
          field: "description",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Flat Rate",
          thClass: "text-left",
          tdClass: "text-left",
          field: "fr",
          //width: "80px",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Target Lead Time",
          thClass: "text-left",
          tdClass: "text-left",
          field: "target_leadtime",
          //width: "80px",
          headerClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Category Problem",
          thClass: "text-left",
          tdClass: "text-left",
          field: "category_problem",
          //width: "80px",
          headerClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Jenis Pekerjaan",
          thClass: "text-left",
          tdClass: "text-left",
          field: "jenis_pekerjaan",
          //width: "120px",
          headerClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Type Perbaikan",
          thClass: "text-left",
          tdClass: "text-left",
          field: "type_perbaikan",
          //width: "150px",
          headerClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rows: [],
      totalRecords: 0,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      rowsSelection: [], // pastikan ini sudah terisi saat select
      isDeleting: false,
    };
  },
  methods: {
    onRowSelected({ selectedRows }) {
      this.rowsSelection = selectedRows;
    },

    async deleteModal() {
      if (!Array.isArray(this.rowsSelection) || this.rowsSelection.length < 1) {
        this.$swal({
          icon: "warning",
          title: "Informasi",
          text: "Silakan pilih data yang ingin dihapus.",
          confirmButtonText: "OK",
        });
        return;
      }

      const result = await this.$swal({
        title: "Konfirmasi",
        text: "Apakah kamu yakin ingin menghapus data ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, Hapus",
        cancelButtonText: "Tidak",
      });

      if (result.isConfirmed) {
        this.deleteSelectedRows();
      }
    },

    async deleteSelectedRows() {
      this.isDeleting = true;

      const ids = this.rowsSelection.map((row) => row.master_activity_id);

      var formData = {
        master_activity_ids: ids,
      };
      //console.log("Data yang dikirim ids : ", formData);
      //return;

      const baseURI =
        this.$settings.endPointFppk + "v1/master-activity-fppk/deleteMass";

      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.errors = [];
            this.success(response.data.datas.messages);
            this.rowsSelection = [];
            this.loadItems();
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        })
        .finally(() => {
          this.isDeleting = false;
        });
    },

    addData() {
      window.location.href = "/fppk-master-activity/add";
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    resetBtn() {
      // this.dateRange= {
      //   startDate:null,
      //   endDate:null
      // };
      this.search.text = "";
      this.search.filterBy = "";
      this.status = [];
      this.loadItems();
    },

    detailData(index, row) {
      this.loading();
      var params = this.$onRandom(row.master_activity_id);
      window.location.href = "/fppk-master-activity/detail/" + params;
    },

    editData(index, row) {
      var params = this.$onRandom(row.master_activity_id);
      window.location.href = "/fppk-master-activity/edit/" + params;
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({
        per_page: params.currentPerPage,
        page: 1, // <-- reset page ke 1
      });
    },

    loadItems() {
      this.fade(true);
      const baseURI = this.$settings.endPointFppk + "v1/master-activity-fppk";
      var columnFilters = this.serverParams.columnFilters;
      var category = encodeURIComponent(columnFilters["category"]);
      var job_no = encodeURIComponent(columnFilters["job_no"]);
      var description = encodeURIComponent(columnFilters["description"]);
      var fr = encodeURIComponent(columnFilters["fr"]);
      var target_leadtime = encodeURIComponent(
        columnFilters["target_leadtime"]
      );
      var category_problem = encodeURIComponent(
        columnFilters["category_problem"]
      );
      var jenis_pekerjaan = encodeURIComponent(
        columnFilters["jenis_pekerjaan"]
      );
      var type_perbaikan = encodeURIComponent(columnFilters["type_perbaikan"]);

      return this.$http
        .get(
          baseURI +
            `?limit=${
              this.serverParams.per_page === -1
                ? 999999
                : this.serverParams.per_page
            }&page=${this.serverParams.page}&sort_field=${
              this.serverParams.sort.field
            }&sort_type=${
              this.serverParams.sort.type
            }&category=${category}&job_no=${job_no}&description=${description}&fr=${fr}&target_leadtime=${target_leadtime}&category_problem=${category_problem}&jenis_pekerjaan=${jenis_pekerjaan}&type_perbaikan=${type_perbaikan}`
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.loading();
        }).catch(error => {
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
          }else{

            if (error.response) {
              if(error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }

        });
    },

    downloadData() {
      this.fade(true);
      const baseURI = this.$settings.endPointFppk + "v1/master-activity-fppk";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";
      var columnFilters = this.serverParams.columnFilters;
      var category = encodeURIComponent(columnFilters["category"]);
      var job_no = encodeURIComponent(columnFilters["job_no"]);
      var description = encodeURIComponent(columnFilters["description"]);
      var fr = encodeURIComponent(columnFilters["fr"]);
      var target_leadtime = encodeURIComponent(
        columnFilters["target_leadtime"]
      );
      var category_problem = encodeURIComponent(
        columnFilters["category_problem"]
      );
      var jenis_pekerjaan = encodeURIComponent(
        columnFilters["jenis_pekerjaan"]
      );
      var type_perbaikan = encodeURIComponent(columnFilters["type_perbaikan"]);

      return this.$http
        .get(
          baseURI +
            `?download=download&limit=${
              this.serverParams.per_page === -1
                ? 999999
                : this.serverParams.per_page
            }&page=${this.serverParams.page}&sort_field=${
              this.serverParams.sort.field
            }&sort_type=${
              this.serverParams.sort.type
            }&category=${category}&job_no=${job_no}&description=${description}&fr=${fr}&target_leadtime=${target_leadtime}&category_problem=${category_problem}&jenis_pekerjaan=${jenis_pekerjaan}&type_perbaikan=${type_perbaikan}`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        }).catch(error => {
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
          }else{

            if (error.response) {
              if(error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }

        });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MasterActivityController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      // if (!rolePermision.method_read) {
      //   this.$router.push("/authorized-error");
      // }
      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },
  },

  mounted() {
    this.loadItems();
    this.fetchIt();
    this.loading();
  },
};
</script>

<style>
.vgt-selection-info-row__actions.vgt-pull-right {
  float: none !important;
  display: inline-block;
  margin-left: 10px; /* spasi setelah "Clear" */
}

.vgt-selection-info-row {
  margin-top: 10px !important;
  position: relative;
  border-bottom: 1px solid #e0e0e0;
}

.text-left {
  text-align: left !important;
  vertical-align: top !important;
}
.text-center {
  text-align: center !important;
  vertical-align: top !important;
}
.text-right {
  text-align: right !important;
  vertical-align: top !important;
}
</style>
